import { hasPermission, hasActiveFeatureGate } from '@sopranodesign/pulse-auth';

import { Broadcast, QueuedBroadcasts } from './Pages/index';

const routes = [
  {
    path: '/broadcast',
    component: Broadcast,
    name: 'Broadcasts',
    canAccess: [
      hasActiveFeatureGate('broadcast'),
      hasPermission('create broadcasts')
    ]
  },
  {
    path: '/broadcast/scheduled',
    component: QueuedBroadcasts,
    name: 'Your scheduled broadcasts',
    canAccess: [
      hasActiveFeatureGate('broadcast'),
      hasPermission('view broadcasts')
    ],
    actions: [
      {
        title: 'Manage your scheduled broadcasts',
        description: 'Create, update and delete your scheduled broadcasts.',
        icon: 'speakerphone'
      }
    ]
  }
];

export default routes;
